export default __webpack_public_path__ + "static/media/dots.95d5afec.svg";